import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Input, InputLabel, MenuItem, TextField, TextareaAutosize } from '@mui/material';
import { useParams } from 'react-router-dom';
import { Spinner } from 'reactstrap'
//import OneDriveTeste from "../OneDriveTeste/OneDriveTeste";
import handleGeneratePdf from '../../../services/handlePdf.js';
import { insert, notifyByEmail, getProdCoordenadorPfId, getProdFinalDownloadHref } from '../../../utils/fc/index.js'
import api_powerapps from '../../../services/powerapps/index'
import { notifyError, notifySuccess } from '../../../utils/notify/index.js'
import oikosApi from '../../../services/oikos/index.js'
import qs from 'qs';
import Select from '../../Template/Input/Select.js';



const ModalFormEntregueAoCliente = ( {dataContratual, tecResp, ...props} ) => {


    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState('');
    const [obsTec, setObsTec] = useState('');
    const [isStatusLoading, setIsStatusLoading] = useState(false);
    const [openModalErro, setOpenModalErro] = useState(false);
    const [emails, setEmails] = useState('');
    const [errorMessage, setErrorMessage] = useState(''); // New state for error message
    const [selFiscais, setSelFiscais] = useState([]); // New state for error message
    const { prod_id, proj_id } = useParams();

    const handleClickOpen = async () => {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'projStake',
        data: {
          projStake_ativo: 1,
          papel_id: 1,
          proj_id: proj_id,
        },
        fields: {
          '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = projStake.pf_id)' : 'pf_emailProf',
          '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = projStake.pf_id)' : 'pf_nomeExibicao'
        }
      })}`);

      const selectFiscaisOptions = res.data.map((item) => {
        return { value: item.pf_id, label: item.pf_nomeExibicao, pf_emailProf: item.pf_emailProf };
      })

      console.log(selectFiscaisOptions)
      setSelFiscais(selectFiscaisOptions);
      setOpen(true);
    };

    const handleClose = () => {
    setOpen(false);
    };


    const handleChange = (event) => {
    setStatus(event.target.value);
    };

    const handleChangeObs = (event) => {
        setObsTec(event.target.value);
    };

    const handleEmailChange = (event) => {
      setEmails(event.target.value);  // Update the string of emails
    };

    const isValidEmail = (email) => {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(email);
    };

    const validateEmails = (emailString) => {
        // Split the string by commas
        const emailList = emailString.split(',').map(email => email.trim());
        // Check if every email in the list is valid
        const allValid = emailList.every(isValidEmail);
        return allValid;
    };

    return (
        <>
          <Button variant="" onClick={handleClickOpen}>
            Entregar ao Cliente
          </Button>
          <Dialog
          fullWidth
          maxWidth= 'sm'
          open={open}
          onClose={handleClose}
          PaperProps={{
          component: 'form',
          onSubmit: async (event) => {
              setIsStatusLoading(true);
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());

              const emailList = emails.split(',').map(email => email.trim());

              if (!validateEmails(emails)) {
                notifyError('Por favor, insira emails válidos separados por vírgula.');
                setIsStatusLoading(false);
                return;  // Stop form submission if validation fails
              }

              try {
                const linkDownloadProdFinalZip = await getProdFinalDownloadHref(props.produto, props.linksProdutos);
                if (!linkDownloadProdFinalZip) {
                  notifyError('Arquivo de produto final não encontrado. Verifique a pasta do produto no OneDrive.');
                  setIsStatusLoading(false);
                  return;
                }

                await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 6, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
                await notifyByEmail(props.produto.prod_id, {emailsCliente: emailList, prodFormato: '.pdf', obs: obsTec, linkDownloadProdFinalZip: linkDownloadProdFinalZip});
                notifySuccess('Produto entregue!');
                console.log('entregue ao cliente');
                handleClose();
                props.setCount(prevState => prevState + 1);
              } catch (err) {
                console.error(err);
                notifyError('Não foi possível concluir a entrega ao cliente.');
              } finally {
                setIsStatusLoading(false);
              }
            /*
            */

          },
          }}
          >
          <DialogTitle>Entrega ao cliente</DialogTitle>
          <DialogContent>
          <div className="d-flex">
              <div className='d-flex flex-column pt-4 flex-fill'>
                  <div className="d-flex justify-content-between mb-3">
                      <div>
                          <span>Técnico Responsável</span>
                          <h6>{tecResp}</h6>
                      </div>
                      <div>
                          <span>Data contratual</span>
                          {(moment(dataContratual, 'DD/MM/YYYY').toDate().getTime() > Date.now()) ? <h6 className='text-success'>{dataContratual}</h6> : <h6 className='text-danger'>{dataContratual}</h6>}
                      </div>
                      <div>
                        <span>Data Entrega</span>
                        {props.dataEntregueAGestao && !props.dataEntregueAoEp &&
                          moment(props.dataEntregueAGestao, 'DD/MM/YYYY').toDate().getTime() > new Date(props.produto.prod_dtInterna).getTime()
                          && <h6 className='text-success'>{props.dataEntregueAGestao}</h6>}
                        {props.dataEntregueAGestao && !props.dataEntregueAoEp &&
                          moment(props.dataEntregueAGestao, 'DD/MM/YYYY').toDate().getTime() < new Date(props.produto.prod_dtInterna).getTime()
                          && <h6 className='text-danger'>{props.dataEntregueAGestao}</h6>}
                        {props.dataEntregueAoEp &&
                          moment(props.dataEntregueAoEp, 'DD/MM/YYYY').toDate().getTime() > new Date(props.produto.prod_dtInterna).getTime()
                          && <h6 className='text-success'>{props.dataEntregueAoEp}</h6>}
                        {props.dataEntregueAoEp &&
                          moment(props.dataEntregueAoEp, 'DD/MM/YYYY').toDate().getTime() < new Date(props.produto.prod_dtInterna).getTime()
                          && <h6 className='text-danger'>{props.dataEntregueAoEp}</h6>}
                      </div>
                  </div>
                  <span>Destinatários (favor separar os emails por vírgula):</span>
                  <Select
                    classNamePrefix="select2-selection mb-2"
                    placeholder="Selecionar fiscal..."
                    options={selFiscais || []}
                    //isDisabled={!selContratoInst || modalData.task_id}
                    onChange={e => {
                      console.log(emails.trim().length)
                      if (emails.trim().length === 0) {
                        setEmails(`${e.pf_emailProf}`);
                      } else {
                        setEmails(emails + `, ${e.pf_emailProf}`);
                        console.log(emails + `, ${e.pf_emailProf}`)
                      }
                    }}
                  />
                  <TextareaAutosize
                      className='mb-5'
                      type="text"
                      placeholder="Digite os emails separados por vírgula"
                      value={emails}
                      onChange={handleEmailChange}
                      fullWidth
                      error={!!errorMessage}  // Show error if there's a validation error
                      helperText={errorMessage}
                  />

                  <span>Corpo do email:</span>
                  <TextareaAutosize
                      placeholder='Corpo do email'
                      margin="dense"
                      id="input_corpo"
                      name="input_corpo"
                      label="Corpo Email"
                      variant="standard"
                      className='mb-3 p-1'
                      onChange={handleChangeObs}
                  />
                  <a target='_blank' href={`${props.produto.prod_drive}`}>Link para a pasta do produto</a>
              </div>
          </div>
          </DialogContent>
          <DialogActions>
          {isStatusLoading && (
              <Button
              autoFocus
              margin="dense"
              id="entregaRevInterna"
              name="entrega_rev_interna"
              label="Entrega a Revisao Interna"
              type="submit"
              variant="outlined"
              disabled
              endIcon={<Spinner/>}
              >Aguarde</Button>
          )}
          {!isStatusLoading && (
              <>
                  <Button onClick={handleClose}>Cancelar</Button>
                  <Button type="submit">Entregar</Button>
              </>
          )}
          </DialogActions>
          </Dialog>
        </>
    )
}

ModalFormEntregueAoCliente.propTypes = {
    dataContratual: PropTypes.string,
    tecResp: PropTypes.string,
};

export default ModalFormEntregueAoCliente;
